import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks/Redux'
import { selectSubRole, selectTariffDetails } from '../../../../../store/reducers/AuthSlice'
import { NavTooltip } from './NavTooltip'
import { TariffIcon } from '../../../../../../shared/components/icons/nav/TariffIcon'
import { setModal } from '../../../../../store/reducers/AppSlice'
import { ChangeTariff } from '../../../../../../shared/components/utility/change-tariff/ChangeTariff'
import { TariffDetailsModal } from '../../../../../../pages/projects/widgets/tariff-details-modal/TariffDetailsModal'
import React from 'react'

export interface ITariffButtonProps {
  /** Свёрнутое меню: только иконка, название плана уходит в тултип справа */
  collapsed?: boolean
}

export const TariffButton = ({ collapsed }: ITariffButtonProps) => {
  const { t } = useTranslation()
  const subRole = useAppSelector(selectSubRole)
  const tariff = useAppSelector(selectTariffDetails)?.tariff
  const dispatch = useAppDispatch()

  // Тариф показываем тем же ролям, что и в верхнем меню
  if (!tariff || !['editor', 'admin'].includes(subRole)) return null

  const expired = tariff.is_subscription_expired

  const planName = expired
    ? t('pages.tariff.planExpired')
    : tariff.type === 'custom'
      ? t('pages.tariff.customPlan')
      : tariff.name

  // У безлимитных планов max_keywords не приходит — счётчик показал бы «168/0»
  const keywords = tariff.max_keywords
    ? `${tariff.used_keywords_count}/${tariff.max_keywords} ${t('pages.tariff.keywords')}`
    : t('pages.tariff.unlimitedKeywords')

  return (
    <NavTooltip disabled={!collapsed} label={planName}>
      <button
        className={clsx(
          'flex h-[44px] min-w-[44px] items-center gap-[8px] rounded-[8px] py-[5px] pl-[12px]',
          {
            ['bg-[#FF5778]']: expired,
            ['bg-white']: !expired,
          },
        )}
        type='button'
        onClick={() =>
          tariff.is_subscription_expired
            ? dispatch(
                setModal({
                  size: 'full',
                  children: <ChangeTariff />,
                  withBackButton: true,
                }),
              )
            : dispatch(
                setModal({
                  children: <TariffDetailsModal />,
                }),
              )
        }
      >
        <div className={clsx({ ['text-white']: expired, ['text-[#A059FF]']: !expired })}>
          <TariffIcon />
        </div>
        <div
          className={clsx(
            'flex flex-col overflow-hidden whitespace-nowrap text-left text-focus-500',
            {
              ['hidden']: collapsed,
            },
          )}
        >
          <p className={clsx('text-[13px] font-medium', { ['text-white']: expired })}>{planName}</p>
          <p
            className={clsx('truncate text-[12px]', {
              ['text-white']: expired,
              ['opacity-40']: !expired,
            })}
          >
            {expired ? t('pages.tariff.clickToUpgrade') : keywords}
          </p>
        </div>
      </button>
    </NavTooltip>
  )
}
